import { MainTemplate } from "@/components/templates";
import config from "@/libs/config";
import Router from "next/router";
import * as util from "@/libs/util";

export const ConnectBoardRedirectToAuthPage = () => {
  const fqdn = config.CONNECT_BOARD_AZUREADB2C_FQDN;
  const tenantName = config.CONNECT_BOARD_AZUREADB2C_TENANT_NAME;
  const policyName = config.CONNECT_BOARD_AZUREADB2C_POLICY_NAME;

  // OIDC 認可コードフローのリクエストパラメータ
  // ------------------------------------------
  // [Note about AzureAD B2C Spec]
  // ややこしいが、AzureAD B2C の仕様では、
  // リクエストパラメータの client_id には `application-ID` を設定する。
  // Client Application (= Mikatano) に対するClientID ではない。
  // ref: https://learn.microsoft.com/ja-jp/azure/active-directory-b2c/access-tokens
  //
  // The above comment can be restated (with elaboration) as:
  // - Microsoft AzureAD B2C uses "application IDs" as "client IDs"
  // - although we define both CONNECT_BOARD_CLIENT_ID and CONNECT_BOARD_APPLICATION_ID
  //   they have always been set to the same value (for BOTH IDV1 (AWS SecretsManager) and IDV2 (cue))
  // - both names are technically correct
  // - moving forward, we will use CONNECT_BOARD_CLIENT_ID and deprecate CONNECT_BOARD_APPLICATION_ID
  const queryString = util.objToQueryString({
    response_type: "code",
    client_id: config.CONNECT_BOARD_CLIENT_ID, // in IDV1, we used CONNECT_BOARD_APPLICATION_ID
    redirect_uri: config.CONNECT_BOARD_REDIRECT_URI,
    scope: "openid",
    max_age: "3600",
  });

  const url = `https://${fqdn}/${tenantName}.onmicrosoft.com/${policyName}/oauth2/v2.0/authorize?${queryString}`;
  Router.push(url);

  return <MainTemplate></MainTemplate>;
};
